//@ts-ignore
import React, {
  useContext, useRef,
  useState
} from "react";
import { ControlBarContext } from "./ControlBarContext";

function FilterElements(props: any) {
  const { arr, name, selected, setSelected } = props;
  const rows: any = [];
  const ref: any = useRef(null);
  const controlBar = useContext(ControlBarContext);

  const handleSelect = (e: string) => {
    let newState = selected;
    if (newState.includes(e)) {
      newState = newState.filter((item: string) => item !== e);
    } else {
      newState = newState.concat(e);
    }
    setSelected(newState);

    // const selection = controlBar?.selection;
    // selection.name = newState;
    const finalState = {
      ...controlBar?.selection,
      [name]: newState,
    };
    controlBar?.setSelection(finalState);
  };

  arr.forEach((obj: any) => {
    rows.push(
      <div className="w-full h-12">
        <button
          key={obj.abbreviation}
          className={`w-full h-full p-2 flex-1 text-center font-semibold leading-none text-sm rounded border-none focus:outline-none ${
            selected.includes(obj.abbreviation)
              ? "bg-blue-400 text-white"
              : "hover:bg-blue-200 hover:text-gray-700"
          }`}
          onClick={() => handleSelect(obj.abbreviation)}
        >
          {obj.name}
        </button>
      </div>
    );
  });

  const gridConfig =
    arr.length > 6
      ? "grid-cols-2 grid-flow-row md:grid-cols-6 sm:grid-cols-3"
      : "";

  return (
    <div
      className={`absolute z-1 my-1 shadow-lg border grid ${gridConfig} gap-2 bg-white rounded-md`}
      ref={ref}
    >
      {rows}
    </div>
  );
}

export default function MultiButtonSelect(props: any) {
  const {
    name,
    filterOptions,
    label,
    isVisible,
    setCurrentActiveFilter,
  } = props;

  console.log(label);

  const [selected, setSelected] = useState<string[]>([]);
  return (
    <div className="max-w-48">
      <button
        className="text-sm font-semibold border-2 flex-1 rounded p-2 hover:bg-gray-200"
        onClick={() => {
          isVisible ? setCurrentActiveFilter("") : setCurrentActiveFilter(name);
        }}
      >
        {label}
      </button>
      {isVisible && (
        <FilterElements
          arr={filterOptions}
          isActive={isVisible}
          setActive={setCurrentActiveFilter}
          name={name}
          selected={selected}
          setSelected={setSelected}
        />
      )}
    </div>
  );
}
